import styled from "styled-components";
import { openSansRegular } from "../../../../StylesConstants";

export const DocumentInfoWrapper = styled.div`
  font: 13px ${openSansRegular};
  line-height: 24px;
`;